import { useSelector } from 'react-redux'
import { googlePaymentRequestParams } from '../../config/payment/googlePay'
import { qrSelector } from '../../redux/slices/qr'

export const useGPayRequestParams = () => {
  const { totalPrice } = useSelector(qrSelector)

  const paymentRequest = structuredClone(googlePaymentRequestParams)
  paymentRequest.transactionInfo.totalPrice = String(totalPrice)
  // paymentRequest.transactionInfo.totalPrice = totalPrice
  // console.log({ paymentRequest, googlePaymentRequestParams })

  return paymentRequest
}
